import { render } from "./EmailBrandingListings.vue?vue&type=template&id=78778e52&scoped=true&ts=true"
import script from "./EmailBrandingListings.vue?vue&type=script&lang=ts"
export * from "./EmailBrandingListings.vue?vue&type=script&lang=ts"

import "./EmailBrandingListings.vue?vue&type=style&index=0&id=78778e52&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78778e52"]])

export default __exports__